export enum StudentStatus{
    ACTIVE = 1
}